﻿
export function getUrlParams(k) {
    var p = {};
    location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (s, k, v) { p[k] = v });
    return k ? p[k] : p;
}

export function removeValueFromCommaList(list, value) {
    return list.toString().replace("," + value, "").replace(value + ",", "").replace(value, "");
}

export function getUrlQueryString(params) {
    var str = "?";
    for (var key in params) {
        if (params[key] == null || params[key] === "") {
            continue;
        }

        if (str != "?") {
            str += "&";
        }

        str += key + "=" + params[key];
    }
    return str === "?" ? "" : str;
}

export function formatIntThousandSeparated(value) {
    if (!value)
        return 0;

    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}
